{
    "Profile_Vehicles.vehicles": "Vehicles",
    "Profile_Vehicles.vehicle": "Vehicle {number}",
    "Profile_Vehicles.driver": "Driver {number}"
}
